<template>
  <div id="cup_player" v-show="currThemeObj">
    <div class="abs_topArea">球 员</div>
    <div class="select_area">
      <cup_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></cup_select_opt>
    </div>
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <nodeTree_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="parentWidthPx"
          :isScrollFlag="isScrollFlag"
          :variableColWidthVw="variableColWidthVw"
          :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
          :defaultWidthVwNum="defaultWidthVwNum"
          :tableColumnData="tableColumnData"
          :tableData="tableData"
          :tableHeightPx="tableHeightPx"
          @clickColumnEvent="clickColumn"
          :jumpRouterPathNames="jumpRouterPathNames"
          v-show="tableData && tableData.length > 0"
        ></nodeTree_table>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import {
  https_cup_playerMatchStatus,
  https_cup_seasonPlayer,
  https_cup_playerPos,
  https_cup_stageteammenu,
} from '@api/platfrom_football_api'
import cup_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import BackTop from '@components/base/backTop.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'cup_player',
  components: {
    cup_select_opt,
    nodeTree_table,
    BackTop,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      loading: false,
      tableMode: 'playerData',
      jumpRouterPathNames: null,
      showBackTop: false,
      scrollDomById: 'containerFull_body',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 25.42,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      currTeam: '-1',
      currAct: null,
      pnum: 1,
      psize: 20,
      teamArr: [],
      posArr: [],
      actArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'team',
            title: '球队',
            origin_keyVal: ['teamId', 'teamName'],
            dataName: 'teamArr',
          },
          {
            type: 'pos',
            title: '位置',
            origin_keyVal: ['code', 'name'],
            dataName: 'posArr',
          },
          {
            type: 'act',
            title: '状态',
            origin_keyVal: ['code', 'name'],
            dataName: 'actArr',
          },
        ],
        selectOpt_list: [],
      },
    }
  },
  created() {
    if (this.currThemeObj) {
      const jumpRouterPathNames = {
        pathName_teamDetail: '',
        pathName_playerDetail: `playerDetailIndex_${this.currThemeObj.moduleRouteNameEn}`,
      }
      this.jumpRouterPathNames = jumpRouterPathNames
    }
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noMore() {
      const curTableDataNum = this.tableData ? this.tableData.length : -1
      return curTableDataNum >= this.tableTotal && this.tableTotal !== 0
    },
    noData() {
      return (
        this.tableTotal === 0 && this.tableData && this.tableData.length === 0
      )
    },
    tableHeightPx() {
      // let clientHeight = window.innerHeight
      //   ? window.innerHeight
      //   : window.screen.height
      //   ? window.screen.height
      //   : 667
      // let clientWidth = window.innerWidth
      //   ? window.innerWidth
      //   : window.screen.width
      //   ? window.screen.width
      //   : 375

      // return clientHeight - (clientWidth / 100) * 42
      return 0
    },
    // tableHeightPx() {
    //   let clientHeight = window.innerHeight
    //     ? window.innerHeight
    //     : window.screen.height
    //     ? window.screen.height
    //     : 667
    //   let clientWidth = window.innerWidth
    //     ? window.innerWidth
    //     : window.screen.width
    //     ? window.screen.width
    //     : 375

    //   return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
    //   // return 500
    // },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.initTableQuery()
      console.debug(this.currCid, this.currSid)
      await this.getstageTeam()
      await this.getPlayerPos()
      await this.getPlayerMatchStatus()
      await this.getRecordPlayerStat()
      console.debug(this.stageArr)
      this.computedSelectOpt(this.selectOptData.configArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    getParentHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375
      return clientHeight - Math.ceil((15 * clientWidth) / 100)
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })

      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      // console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom,
      //   this.matchTotal,
      //   this.curMatchListNum
      // )
      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          this.load()
          if (this.pnum > this.allPages) {
            this.isScrollBottom = true
          }
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }
      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
        this.parentHeightPx = this.getParentHeightPx()
      } else {
        console.debug('dom 不存在')
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        console.debug(config.dataName, this[config.dataName])
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[0][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[0][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在cup_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'team') {
            this.currTeam = valPathArr[1]
          } else if (valPathArr[0] === 'pos') {
            this.currPos = valPathArr[1]
          } else if (valPathArr[0] === 'act') {
            this.currAct = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.initTableQuery()
          this.tableColumnData = []
          this.getRecordPlayerStat()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    load() {
      if (this.noMore || this.loading) {
        return
      }
      this.getRecordPlayerStat()
    },
    clickColumn(prop) {
      console.debug(prop)
      this.initTableQuery()
      this.getRecordPlayerStat()
    },
    initTableQuery() {
      this.pnum = 1
    },
    async getstageTeam() {
      await https_cup_stageteammenu(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.teamArr = res.data ? res.data : []
            this.teamArr.unshift({
              teamId: '-1',
              teamName: '全部球队',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPlayerPos() {
      await https_cup_playerPos(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.posArr = res.data ? res.data : []
            if (this.posArr.length > 0) {
              this.currPos = this.posArr[0].code
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPlayerMatchStatus() {
      await https_cup_playerMatchStatus(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.actArr = res.data ? res.data : []
            if (this.actArr.length > 0) {
              this.currAct = this.actArr[0].code
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getRecordPlayerStat() {
      this.loading = true
      await https_cup_seasonPlayer(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
        tid: this.currTeam == '-1' ? '' : this.currTeam,
        pos: this.currPos,
        act: this.currAct,
        pnum: this.pnum,
        psize: this.psize,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data) {
              this.tableTotal = res.data.total
              const columns = [
                {
                  colKey: 'rankNum',
                  colTitle: '排名',
                },
                {
                  colKey: 'playerName',
                  colTitle: '球员名称',
                },
                {
                  colKey: 'playerLogo',
                  colTitle: '球员头像',
                },
                {
                  colKey: 'shirtNumber',
                  colTitle: '号码',
                },
                {
                  colKey: 'positionName',
                  colTitle: '位置',
                },
                {
                  colKey: 'teamLogo-teamName',
                  colTitle: '球队',
                },
                {
                  colKey: 'isActiveName',
                  colTitle: '状态',
                },
              ]
              const fristColumns = columns.slice(0, 3)
              const otherColumns = columns.slice(3)
              this.defaultWidthVwNum = otherColumns.length - 1 //减去这一列teamLogo-teamName
              if (this.tableColumnData.length == 0) {
                let tableColumnData = []
                let fristColumnPropArr = []
                for (let i = 0; i < fristColumns.length; i++) {
                  fristColumnPropArr.push(fristColumns[i].colKey)
                }
                const fristColumn = {
                  prop: 'rankNum-playerLogo-playerName', //fristColumnPropArr.join('-'),
                  label: '球员',
                  widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                  className: 'columnNumLogoNameClass', //单独定制的头部样式class
                  fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                }

                tableColumnData.push(fristColumn)
                for (let i = 0; i < otherColumns.length; i++) {
                  const item = otherColumns[i]
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw:
                      item.colKey != 'teamLogo-teamName'
                        ? this.tableCellDefaultWidthVw
                        : 20, //对应列的宽度，单位vw
                    className:
                      item.colKey != 'teamLogo-teamName'
                        ? ''
                        : 'columnLogoNameClass', //单独定制的头部样式class
                    selected: '',
                  })
                }
                // console.debug('res.data：',res.data)
                this.tableColumnData = tableColumnData
              }
              if (this.pnum == 1) {
                let indexNo = 0
                this.tableData = res.data.list
                  ? res.data.list.map((val) => {
                      this.actArr.forEach((item) => {
                        if (item.code == val.isActive) {
                          val.isActiveName = item.name
                        }
                      })
                      indexNo++
                      val.rankNum = indexNo
                      return val
                    })
                  : []
                this.initScroll()
              } else {
                let indexNo =
                  this.tableData && this.tableData.length > 0
                    ? this.tableData.length
                    : 0
                this.tableData = this.tableData.concat(
                  res.data
                    ? res.data.list.map((val) => {
                        this.actArr.forEach((item) => {
                          if (item.code == val.isActive) {
                            val.isActiveName = item.name
                          }
                        })
                        indexNo++
                        val.rankNum = indexNo
                        return val
                      })
                    : []
                )
              }
            } else {
              console.debug('暂无数据')
            }

            if (this.tableTotal >= this.tableData.length) {
              if (this.tableTotal === 0) {
                this.tableData = []
              } else {
                if (this.pnum !== 1) {
                  this.$nextTick(() => {
                    if (this.scrollAreaDom) {
                      this.scrollAreaDom.scrollTo(0, this.beforeScrollTop)
                    }
                    this.loading = false
                  })
                } else {
                  this.$nextTick(() => {
                    this.loading = false
                  })
                }
                this.pnum++
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_player {
  .abs_topArea {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 2vw 0 0 9.722vw;
    width: 100%;
    height: 8.68vw;
    font-size: 3vw;
    line-height: 6.68vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_detail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
  }
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0;
    .tableScrollArea {
      /* height: calc(100vh - 15vw);
      overflow: auto; */
      height: auto;
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
.mixtmt_pc #cup_player,
.mixtmt_ipad #cup_player {
  padding: 8.68vw 0 0;
}
</style>
